import { combineReducers, configureStore, type ConfigureStoreOptions } from '@reduxjs/toolkit'
import { cloudServicesManagerApi } from "../api/cloudServicesManagerApi.ts";
import { type TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { appContextReducer } from "./appContextReducer.ts";
import * as Sentry from "@sentry/react";

const sentryReduxEnhancer = Sentry.createReduxEnhancer({

});

const reducers = combineReducers({
    appContext: appContextReducer,
    [cloudServicesManagerApi.reducerPath]: cloudServicesManagerApi.reducer
})

export const createStore = (options?: ConfigureStoreOptions['preloadedState'] | undefined) =>
    configureStore({
        reducer: reducers,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(cloudServicesManagerApi.middleware),
        ...options,
        enhancers: (getDefaultEnhancers) => {
            return getDefaultEnhancers().concat(sentryReduxEnhancer);
        },
    })

export const appStore = createStore()

export type AppDispatch = typeof appStore.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export type AppState = ReturnType<typeof appStore.getState>
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
